import {API_V1} from "../config/main-axios";

class Package {
    getAllPackage(data) {
        return API_V1.get("/shop/admin/package/", {
            params: data
        })
    }

    addPackage(data) {
        return API_V1.post(`/shop/admin/package/`, data)
    }

    deletePackage(id) {
        return API_V1.delete(`/shop/admin/package/${id}/`)
    }

    updatePackage(id, data) {
        return API_V1.patch(`/shop/admin/package/${id}/`, data)
    }
}

export default new Package();
